import { PureComponent } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
class Icon extends PureComponent {
  render() {
    const {
      iconData,
      height,
      width,
      onIconSelect,
      className,
      color
    } = this.props;
    const {
      name,
      svg,
      viewPort
    } = iconData;
    const iconStyle = {
      height,
      width
    };
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "cmv2-icon",
      "data-value": name,
      className: className,
      onClick: () => onIconSelect(iconData),
      children: /*#__PURE__*/_jsx("svg", {
        className: "icon-svg",
        viewBox: viewPort ? viewPort.join(' ') : '',
        style: iconStyle,
        children: /*#__PURE__*/_jsx("path", {
          fill: color,
          d: svg
        })
      })
    });
  }
}
Icon.defaultProps = {
  height: 25,
  width: 25,
  color: OBSIDIAN,
  onIconSelect: emptyFunction
};
export default Icon;